import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Actions, Effect} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Router, Event, NavigationStart} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {
  startOfDay,
  endOfDay,
  differenceInMonths,
  addDays,
  endOfMonth,
  getMinutes,
  addMonths,
  getHours,
  isEqual,
  differenceInDays,
  format
} from 'date-fns';

import {RequestService} from '../services/request.service';
import {GetOptions} from '../services/interfaces/request.interfaces';

import {State} from '../reducers';
import {
  DataAction,
  DATA_REQUEST,
  DATA_REQUEST_SUCCESS,
  DATA_REQUEST_FAILURE,
} from '../actions/data.action';
import {INFO_UPDATE} from '../actions/info.action';
import {OVERLAY_FINISH} from '../actions/header.action';
import {GetCredentialsResponse} from './interfaces/data.interfaces';

/// <reference path="../node_modules/@types/gapi/index.d.ts" />
/// <reference path="../node_modules/@types/gapi.calendar/index.d.ts" />

@Injectable()
export class DataEffect {
  private options: GetOptions<GetCredentialsResponse>;
  private week: any = null;
  private endDate: Date;
  public practitionerEvents: Array<{ start: any, end: any }> = [];

  constructor(
    private requestService: RequestService,
    private actions$: Actions,
    private store: Store<State>,
    private router: Router
  ) {
    this.options = {
      url: '/data',
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this),
      },
    };
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        sessionStorage.setItem('prevStep', window.location.hash.split('/')[2]);
      }
    });
  }

  public success(response: GetCredentialsResponse): void {
    console.log('RESPONSE', response);
    this.store.dispatch({type: OVERLAY_FINISH});

    if (response['events']) {
      this.practitionerEvents = [];
      // if event lasts more then 1 day adding pseudo events for calendar
      response['events'].forEach((event) => {
        if (differenceInDays(event.end, event.start) >  0) {
          let start = event.start;
          const end = event.end;
          let day = differenceInDays(event.end, event.start) + 1;
          while (day > 0) {
            this.practitionerEvents.push({start: start, end: differenceInDays(end, start) === 0 ? end : format(endOfDay(start))});
            start = format(startOfDay(addDays(start, 1)));
            day--;
          }
        } else {
          this.practitionerEvents.push(event);
        }
      });
      // create date events for calendar
      this.store.dispatch({type: OVERLAY_FINISH});
      const arrayOfResults = [];
      this.practitionerEvents.forEach((item) => {
        const arrayOfTimes = [];
        if (getHours(item.start) < 12) {
          if (getHours(item.end) < 12) {
            arrayOfTimes.push('Morning!');
          } else if (getHours(item.end) < 16) {
            arrayOfTimes.push('Morning!');
            arrayOfTimes.push('Afternoon!');
          } else {
            arrayOfTimes.push('Morning!');
            arrayOfTimes.push('Afternoon!');
            arrayOfTimes.push('Evening!');
          }
        } else if (getHours(item.start) < 16) {
          if (getHours(item.end) < 16) {
            arrayOfTimes.push('Afternoon!');
          } else {
            arrayOfTimes.push('Evening!');
            arrayOfTimes.push('Afternoon!');
          }
          arrayOfTimes.push('Afternoon!');
        } else {
          arrayOfTimes.push('Evening!');
        }
        arrayOfTimes.forEach((time) => {
          if (
            !arrayOfResults.find(
              (result) => {
                return isEqual(result.start, startOfDay(item.start)) &&
                result.title === time;
              }

            )
          ) {
            arrayOfResults.push({
              start: startOfDay(item.start),
              dayStart: item.start,
              dayEnd: item.end,
              title: time,
              color: {
                primary:
                  time === 'Morning!'
                    ? '#ff800a'
                    : time === 'Afternoon!'
                    ? '#88cccd'
                    : '#d8d8d8',
              },
            });
          }
        });
      });
      const data = {
        arr: [],
        start: new Date(),
        endOfNextMonth: endOfDay(
          endOfMonth(
            addMonths(
              new Date(),
              differenceInMonths(this.endDate, new Date()) < 0
                ? 2
                : differenceInMonths(this.endDate, new Date()) + 1
            )
          )
        ),
      };
      // check if practitioner has free time
      while (endOfDay(data.start).getTime() !== data.endOfNextMonth.getTime()) {
        if (
          arrayOfResults.find(
            (result) => {
              return startOfDay(result.start).getTime() ===
              startOfDay(data.start).getTime();
            }
          ) &&
          this.week.find(
            (dayOfWeek) =>
              dayOfWeek.day ===
              [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ][data.start.getDay()]
          ).startTime
        ) {
          const dayWithEventData = arrayOfResults.find(
            (result) =>
              startOfDay(result.start).getTime() ===
              startOfDay(data.start).getTime()
          );
          const arrOfTimesForCurrentDay = arrayOfResults.filter((result) => {
            if (
              startOfDay(result.start).getTime() ===
              startOfDay(data.start).getTime()
            ) {
              return result.title;
            }
          });
          const workDay = this.week.find(
            (dayOfWeek) =>
              dayOfWeek.day ===
              [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ][data.start.getDay()]
          );
          const workTime = {
            morning: null,
            evening: null,
            afternoon: null,
          };
          const workTimeString = {
            morning: [],
            evening: [],
            afternoon: [],
          };
          if (+workDay.startTime.split(':')[0] < 12) {
            workTime.morning =
              ((+workDay.endTime.split(':')[0] >= 12
                ? 12
                : +workDay.endTime.split(':')[0]) -
                workDay.startTime.split(':')[0]) *
              60;
            let start =
              +workDay.startTime.split(':')[0] >= 12
                ? `12:00`
                : `${workDay.startTime.split(':')[0]}:${
                  workDay.startTime.split(':')[1]
                }`;
            while (start < '12:00') {
              workTimeString.morning.push(start);
              if (
                +start.slice(3) + +localStorage.getItem('treatmentTime') >=
                60
              ) {
                start = `${+start.slice(0, 2) + 1}:${
                  +start.slice(3) +
                  +localStorage.getItem('treatmentTime') -
                  60 <
                  10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60 +
                    '0'
                    : +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60
                }`;
              } else {
                start = `${start.slice(0, 2)}:${
                  +start.slice(3) + +localStorage.getItem('treatmentTime') < 10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') +
                    '0'
                    : +start.slice(3) + +localStorage.getItem('treatmentTime')
                }`;
              }
            }
            // workTimeString.morning = +workDay.endTime.split(':')[0] >= 12 ? `12`(( ? 12 : +workDay.endTime.split(':')[0]) - workDay.startTime.split(':')[0]) * 60;
          }
          if (
            +workDay.startTime.split(':')[0] < 16 &&
            +workDay.endTime.split(':')[0] > 12
          ) {
            workTime.afternoon =
              ((+workDay.endTime.split(':')[0] < 16
                ? +workDay.endTime.split(':')[0]
                : 16) -
                (+workDay.startTime.split(':')[0] > 12
                  ? +workDay.startTime.split(':')[0]
                  : 12)) *
              60;
            let start =
              +workDay.startTime.split(':')[0] >= 16
                ? `16:00`
                : workDay.startTime.split(':')[0] < 12
                ? `12:00`
                : `${workDay.startTime.split(':')[0]}:${
                  workDay.startTime.split(':')[1]
                }`;
            while (start < '16:00') {
              workTimeString.afternoon.push(start);
              if (
                +start.slice(3) + +localStorage.getItem('treatmentTime') >=
                60
              ) {
                start = `${+start.slice(0, 2) + 1}:${
                  +start.slice(3) +
                  +localStorage.getItem('treatmentTime') -
                  60 <
                  10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60 +
                    '0'
                    : +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60
                }`;
              } else {
                start = `${start.slice(0, 2)}:${
                  +start.slice(3) + +localStorage.getItem('treatmentTime') < 10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') +
                    '0'
                    : +start.slice(3) + +localStorage.getItem('treatmentTime')
                }`;
              }
            }
          }
          if (+workDay.endTime.split(':')[0] >= 16) {
            workTime.evening =
              (+workDay.startTime.split(':')[0] > 16
                ? +workDay.startTime.split(':')[0] - 16
                : +workDay.endTime.split(':')[0] - 16) * 60;
            let start =
              +workDay.startTime.split(':')[0] > 16
                ? `${workDay.startTime.split(':')[0]}:${
                  workDay.startTime.split(':')[1]
                }`
                : `16:00`;
            while (
              start <
              `${workDay.endTime.split(':')[0]}:${
                workDay.endTime.split(':')[1]
              }`
              ) {
              workTimeString.evening.push(start);
              if (
                +start.slice(3) + +localStorage.getItem('treatmentTime') >=
                60
              ) {
                start = `${+start.slice(0, 2) + 1}:${
                  +start.slice(3) +
                  +localStorage.getItem('treatmentTime') -
                  60 <
                  10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60 +
                    '0'
                    : +start.slice(3) +
                    +localStorage.getItem('treatmentTime') -
                    60
                }`;
              } else {
                start = `${start.slice(0, 2)}:${
                  +start.slice(3) + +localStorage.getItem('treatmentTime') < 10
                    ? +start.slice(3) +
                    +localStorage.getItem('treatmentTime') +
                    '0'
                    : +start.slice(3) + +localStorage.getItem('treatmentTime')
                }`;
              }
            }
          }
          arrOfTimesForCurrentDay.forEach((event) => {
            const workEventTime = {
              // This will be needed if use timezones
              // start: getHours(subHours(event.dayStart, getTimeZone().hours)),
              // end: getHours(subHours(event.dayEnd, getTimeZone().hours)),
              start: getHours(event.dayStart),
              end: getHours(event.dayEnd),
              during:
                (getHours(event.dayStart) - getHours(event.dayEnd)) * 60 +
                (getMinutes(event.dayEnd) - getMinutes(event.dayStart)),
            };
            if (
              workTime.morning &&
              workEventTime.start < 12 &&
              workEventTime.during
            ) {
              workTime.morning -= workEventTime.during;
              workTimeString.morning = workTimeString.morning.filter((time) => {
                const timeInMinutes = +time.slice(0, 2) * 60 + +time.slice(3);
                // This will be needed if use timezones
                // const start = getHours(subHours(event.dayStart, getTimeZone().hours)) * 60 + getMinutes(event.dayStart);
                // const end = getHours(subHours(event.dayEnd, getTimeZone().hours)) * 60 + getMinutes(event.dayEnd);
                const start =
                  getHours(event.dayStart) * 60 + getMinutes(event.dayStart);
                const end =
                  getHours(event.dayEnd) * 60 + getMinutes(event.dayEnd);
                return !(end > 1435 || (timeInMinutes > start && timeInMinutes < end) ||
                  (timeInMinutes < start &&
                    timeInMinutes + +localStorage.getItem('treatmentTime') >
                    start &&
                    (timeInMinutes + +localStorage.getItem('treatmentTime') <
                      end ||
                      timeInMinutes + +localStorage.getItem('treatmentTime') >
                      end)));
              });
            }
            if (
              workTime.afternoon &&
              workEventTime.start < 16 &&
              workEventTime.end >= 12 &&
              workEventTime.during
            ) {
              workTime.afternoon -= workEventTime.during;
              workTimeString.afternoon = workTimeString.afternoon.filter(
                (time) => {
                  const timeInMinutes = +time.slice(0, 2) * 60 + +time.slice(3);
                  // This will be needed if use timezones
                  // const start = getHours(subHours(event.dayStart, getTimeZone().hours)) * 60 + getMinutes(event.dayStart);
                  // const end = getHours(subHours(event.dayEnd, getTimeZone().hours)) * 60 + getMinutes(event.dayEnd);
                  const start =
                    getHours(event.dayStart) * 60 + getMinutes(event.dayStart);
                  const end =
                    getHours(event.dayEnd) * 60 + getMinutes(event.dayEnd);
                  return !((timeInMinutes >= start && timeInMinutes <= end) ||
                    (timeInMinutes <= start &&
                      timeInMinutes + +localStorage.getItem('treatmentTime') >=
                      start &&
                      (timeInMinutes + +localStorage.getItem('treatmentTime') <=
                        end ||
                        timeInMinutes +
                        +localStorage.getItem('treatmentTime') >=
                        end)));
                }
              );
            }
            if (
              workTime.evening &&
              workEventTime.end >= 16 &&
              workEventTime.during
            ) {
              workTime.evening -= workEventTime.during;
              workTimeString.evening = workTimeString.evening.filter((time) => {
                const timeInMinutes = +time.slice(0, 2) * 60 + +time.slice(3);
                // This will be needed if use timezones
                // const start = getHours(subHours(event.dayStart, getTimeZone().hours)) * 60 + getMinutes(event.dayStart);
                // const end = getHours(subHours(event.dayEnd, getTimeZone().hours)) * 60 + getMinutes(event.dayEnd);
                const start =
                  getHours(event.dayStart) * 60 + getMinutes(event.dayStart);
                const end =
                  getHours(event.dayEnd) * 60 + getMinutes(event.dayEnd);
                return !((timeInMinutes >= start && timeInMinutes <= end) ||
                  (timeInMinutes <= start &&
                    timeInMinutes + +localStorage.getItem('treatmentTime') >=
                    start &&
                    (timeInMinutes + +localStorage.getItem('treatmentTime') <=
                      end ||
                      timeInMinutes + +localStorage.getItem('treatmentTime') >=
                      end)));
              });
            }
          });
          if (
            workTime.morning &&
            workTime.morning > 0 &&
            workTime.morning > +localStorage.getItem('treatmentTime') &&
            workTimeString.morning.length
          ) {
            data.arr.push({
              start: data.start,
              dayStart: dayWithEventData.dayStart,
              dayEnd: dayWithEventData.dayEnd,
              title: 'Morning!',
              location: workDay.location,
              color: {
                primary: '#ff800a',
              },
            });
          }
          if (
            workTime.afternoon &&
            workTime.afternoon > 0 &&
            workTime.afternoon > +localStorage.getItem('treatmentTime') &&
            workTimeString.afternoon.length
          ) {
            data.arr.push({
              start: data.start,
              dayStart: dayWithEventData.dayStart,
              dayEnd: dayWithEventData.dayEnd,
              title: 'Afternoon!',
              location: workDay.location,
              color: {
                primary: '#88cccd',
              },
            });
          }
          if (
            workTime.evening &&
            workTime.evening > 0 &&
            workTime.evening > +localStorage.getItem('treatmentTime') &&
            workTimeString.evening.length
          ) {
            data.arr.push({
              start: data.start,
              dayStart: dayWithEventData.dayStart,
              dayEnd: dayWithEventData.dayEnd,
              title: 'Evening!',
              location: workDay.location,
              color: {
                primary: '#d8d8d8',
              },
            });
          }
        } else if (this.week) {
          const workDay = this.week.find(
            (dayOfWeek) =>
              dayOfWeek.day ===
              [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ][data.start.getDay()]
          );
          if (workDay.startTime && +workDay.startTime.slice(0, 2) < 12) {
            data.arr.push({
              start: data.start,
              dayStart: null,
              dayEnd: null,
              title: 'Morning!',
              location: workDay.location,
              color: {
                primary: '#ff800a',
              },
            });
          }
          if (workDay.startTime && +workDay.startTime.slice(0, 2) < 16) {
            data.arr.push({
              start: data.start,
              dayStart: null,
              dayEnd: null,
              title: 'Afternoon!',
              location: workDay.location,
              color: {
                primary: '#88cccd',
              },
            });
          }
          if (
            workDay.endTime &&
            ((+workDay.endTime.slice(0, 2) > 16 &&
              +workDay.endTime.slice(3) >= 0) ||
              (+workDay.endTime.slice(0, 2) === 16 &&
                +workDay.endTime.slice(3) > 0))
          ) {
            data.arr.push({
              start: data.start,
              dayStart: null,
              dayEnd: null,
              title: 'Evening!',
              location: workDay.location,
              color: {
                primary: '#d8d8d8',
              },
            });
          }
        }
        data.start = addDays(data.start, 1);
      }
      // if (this.week && this.week.length) {
      //   data.arr = data.arr.filter((dateOfWork) => {
      //     let answer = true;
      //     // const workDay = this.week.find(dayOfWeek => dayOfWeek.day === ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dateOfWork.start.getDay()]);
      //     response["events"].forEach((event) => {
      //       if (
      //         dateOfWork.dayStart &&
      //         dateOfWork.dayStart === event.start &&
      //         dateOfWork.title === "Morning!"
      //       ) {
      //         answer = false;
      //       }
      //       if (
      //         dateOfWork.dayEnd &&
      //         dateOfWork.dayEnd === event.end &&
      //         dateOfWork.title === "Evening!"
      //       ) {
      //         answer = false;
      //       }
      //     });
      //     // if (isToday(dateOfWork.start)) {
      //     //   if ((getHours(new Date()) * 60 + getMinutes(new Date())) > 12 * 60 && dateOfWork.title === 'Morning!') {
      //     //     answer = false;
      //     //   }
      //     //   if ((getHours(new Date()) * 60 + getMinutes(new Date())) > 16 * 60 && dateOfWork.title === 'Afternoon!') {
      //     //     answer = false;
      //     //   }
      //     //   if ((getHours(new Date()) * 60 + getMinutes(new Date())) > workDay.startTime.splite(':')[0] * 60 + workDay.startTime.splite(':')[1] && dateOfWork.title === 'Evening!') {
      //     //     answer = false;
      //     //   }
      //     // }
      //     return answer;
      //   });
      // }
      this.store.dispatch({
        type: DATA_REQUEST_SUCCESS,
        payload: {
          date: data.arr,
          dateBusy: arrayOfResults,
          practitionerEvents: this.practitionerEvents,
          url: null,
        },
      });
      if (localStorage.getItem('day')) {
        this.store.dispatch({
          type: DATA_REQUEST,
          payload: {
            requestUrl:
              `/online-booking/${localStorage.getItem('practitionerId')}/day/` +
              [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ][new Date(JSON.parse(localStorage.getItem('day'))).getDay()],
          },
        });
      }
    } else {
      const clinics = response['clinics'];
      const treatments = response['treatments'];
      const practitioners = response['practitioners'];
      const prevStep = sessionStorage.getItem('prevStep');
      if (response.week) {
        this.week = response.week;
      }
      if (clinics && clinics.length === 1 && prevStep !== 'treatment') {
        const clinicId = clinics[0].id;
        this.store.dispatch({
          type: INFO_UPDATE,
          payload: {
            clinic: clinics[0],
          },
        });
        localStorage.setItem('clinicId', clinicId);
        this.router.navigate([`${localStorage.getItem('AppId')}/treatment`]);
      }
      if (clinics && clinics.length === 1 && prevStep === 'treatment') {
        this.router.navigate([`${localStorage.getItem('AppId')}/home`]);
      }
      if (
        treatments &&
        treatments.length === 1 &&
        treatments[0].prices.length === 1 &&
        prevStep !== 'practitioner'
      ) {
        const treatmentId = treatments[0].id;
        const treatmentTime = treatments[0].defaultLength;
        this.store.dispatch({
          type: INFO_UPDATE,
          payload: {
            treatment: treatments[0],
            price: treatments[0].prices[0],
          },
        });
        localStorage.setItem('treatmentId', treatmentId);
        localStorage.setItem('treatmentTime', treatmentTime);
        this.router.navigate([`${localStorage.getItem('AppId')}/practitioner`]);
      }
      if (
        treatments &&
        treatments.length === 1 &&
        treatments[0].prices.length === 1 &&
        prevStep === 'practitioner'
      ) {
        this.router.navigate([`${localStorage.getItem('AppId')}/clinic`]);
      }
      if (
        practitioners &&
        practitioners.length === 1 &&
        prevStep !== 'date' &&
        (!JSON.parse(localStorage.getItem('treatmentPractitioners'))[
            +localStorage.getItem('treatmentId')
            ] ||
          !JSON.parse(localStorage.getItem('treatmentPractitioners'))[
            +localStorage.getItem('treatmentId')
            ].match(practitioners[0].id))
      ) {
        const practitionerId = practitioners[0].id;
        this.store.dispatch({
          type: INFO_UPDATE,
          payload: {
            practitioner: practitioners[0],
          },
        });
        localStorage.setItem('practitionerId', practitionerId);
        this.router.navigate([`${localStorage.getItem('AppId')}/date`]);
      }
      if (practitioners && practitioners.length === 1 && prevStep === 'date') {
        this.router.navigate([`${localStorage.getItem('AppId')}/treatment`]);
      }
      this.store.dispatch({type: OVERLAY_FINISH});
      this.store.dispatch({
        type: DATA_REQUEST_SUCCESS,
        payload: response,
      });
    }
  }

  // error handler
  public error(httpErrorResponse: HttpErrorResponse): void {
    this.store.dispatch({type: OVERLAY_FINISH});
    this.store.dispatch({type: DATA_REQUEST_FAILURE});
  }

  @Effect()
  public data$: Observable<any> = this.actions$
    .ofType(DATA_REQUEST)
    .map((action: DataAction) => action)
    .mergeMap((state) => {
      this.options.url = state.payload['requestUrl'];
      if (state.payload['requestUrl'].match('calendar')) {
        this.endDate = new Date(state.payload['requestUrl'].split('end=')[1]);
      }
      this.requestService.get<GetCredentialsResponse>(this.options);
      return Observable.of({
        type: 'DATA_REQUEST_PROCESSING',
      });
    });
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/effects/data.effect.ts